import { useEffect, useState } from "react";

import FormModal from "../../widgets/FormModal";

function Ready() {

  const [show, setShow] = useState(false);
  const openIframeWindow = () => {
    setShow(!show);
  }

  return (
    <>
      <section className="you_ready_sec text-center text-md-start  position-relative overflow-hidden">
        <img
          src="/assets/img/cour_raddy.webp"
          alt="cour raddy"
          className="cour_raddy mo_none"
        />
        <img
          src="/assets/img/cour_raddy2.webp"
          alt="cour raddy"
          className="cour_raddy pc_none"
        />
        <div className="container position-relative">
          <div className="row position-relative">
            <div className="col-md-5  ">
              <h2 className="hadding mb-4    ">
                Are You Ready to Take Control of Your Future Health?
              </h2>
              <p className=" mb-md-4 mb-3 ">
                EPLIMO is more than a health check. It’s a blueprint for living
                stronger, longer, and happier. Don’t wait for symptoms to become
                problems. Take charge today and start living at your peak.
              </p>
              <a className="btn" onClick={() => openIframeWindow()}>
                Join EPLIMO<sup className="sup-font">TM</sup> Program
              </a>
            </div>
          </div>
        </div>
        <FormModal show={show} setShow={setShow} />
      </section>
    </>
  );
}

export default Ready;
